import React, { useEffect, useState } from 'react';

const ScrollProgressBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.pageYOffset / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-1 z-[60] pointer-events-none overflow-hidden">
      {/* Outer Glow Container */}
      <div 
        className="h-full bg-gradient-to-r from-primary via-secondary to-accent transition-all duration-150 ease-out shadow-[0_0_15px_rgba(20,184,166,0.8),0_0_5px_rgba(255,255,255,1)]"
        style={{ width: `${scrollProgress}%` }}
      />
      
      {/* Dynamic Sparkle Effect at the tip */}
      <div 
        className="absolute top-0 h-full w-4 bg-white blur-[4px] transition-all duration-150"
        style={{ left: `calc(${scrollProgress}% - 8px)` }}
      />
    </div>
  );
};

export default ScrollProgressBar;
